// extracted by mini-css-extract-plugin
export var statItem = "_l5-1";
export var statsRow = "_l5-0";